import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addVideo({ dispatch, commit }, video) {
    try {
      const { data } = await request.post('videos', video);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
